import PopUp from './PopUp';

export default PopUp;



// WEBPACK FOOTER //
// ../core/src/components/PopUp/index.js